import { render } from "./MultipleOrientedSelect.vue?vue&type=template&id=3899dc42"
import script from "./MultipleOrientedSelect.vue?vue&type=script&lang=js"
export * from "./MultipleOrientedSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__